import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class BlogImageSlide extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get type() {
    return get(this, 'system.type', '');
  }

  get imageSlide() {
    return get(this, '_image_slide.value[0].url', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/BlogImageSlide.model.js